export const muiListOverrides = {
  root: {
    fontFamily: "var(--copytext-font-family)",
    background: "transparent",
    "& .MuiMenuItem-root": {
      fontSize: 16,
      height: "3em",
      padding: "8px 16px",
      color: "var(--color-black)",
      cursor: "default",
      background: "transparent",
      "&.Mui-selected": {
        background: "var(--color-steel-100)",
        "&:hover": { backgroundColor: "var(--color-steel-100)" },
      },
      "&:hover": {
        backgroundColor: "var(--color-steel-100)",
      },
    },
  },
};
